<template>
  <div>
    <slot name="header"></slot>
    <div class="c-dropdown__under block sm:flex md:block rounded-lg">
      <div class="c-research__filter-block">
        <div class="sm:hidden md:block">
          <h3>
            Filter
          </h3>
        </div>
        <div class="c-research__status">
          <p class="font-bold">
            Status
          </p>
          <div class="c-research__status-filter">
            <div class="inline-block">
              <label class="status-checkbox group hover:cursor-pointer relative flex items-end">
                <input @change="changeStatus('lopend')" class="peer hidden" value="lopend" type="checkbox">
                <span class="flex ml-4 group-hover:underline">Lopend</span>
                <i
                  class="absolute top-[5px] left-0 h-3.5 w-3.5 border border-black rounded-sm bg-transparent peer-checked:bg-orange-400 group-hover:bg-gray-200"></i>
              </label>
            </div>
            <div class="inline-block">
              <label class="status-checkbox group hover:cursor-pointer relative flex items-end">
                <input @change="changeStatus('afgerond')" class="peer hidden" type="checkbox">
                <span class="flex ml-4 group-hover:underline">Afgerond</span>
                <span
                  class="absolute top-[5px] left-0 h-3.5 w-3.5 border border-black rounded-sm bg-transparent peer-checked:bg-orange-400 group-hover:bg-gray-200"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="c-research__filter-dropdown">
          <slot name="techniques"></slot>
          <slot name="impacts"></slot>
          <slot name="years"></slot>
          <slot name="tags"></slot>
        </div>
        <div class="w-full hidden sm:flex md:hidden justify-end">
          <button @click="applyFilters()" class="c-button c-button__orange c-button__medium">
            Gereed
          </button>
        </div>
      </div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchFilter",

  data() {
    let url = new URL(window.location.href);
    return {
      sort: url.searchParams.get("sortby") ? url.searchParams.get("sortby").split(',') : [],
      technique: url.searchParams.get("technique") ? url.searchParams.get("technique") : '',
      impact: url.searchParams.get("impact") ? url.searchParams.get("impact") : '',
      tags: url.searchParams.get("tags") ? url.searchParams.get("tags") : '',
      year: url.searchParams.get("years") ? url.searchParams.get("years") : '',
      status: url.searchParams.get("status") ? url.searchParams.get("status").split(',') : ['lopend', 'afgerond']
    }
  },

  props: {
    activeClassName: String,
    notActiveClassName: String,
    wrapper: String,
    clickables: String,
    sortWrapper: String,
    checkboxWrapper: String,
    checkboxSort: String
  },

  mounted() {
    let statuscheckbox = document.getElementsByClassName('status-checkbox')
    for (let i = 0; i < statuscheckbox.length; i++) {
      if (this.status.includes(statuscheckbox[i].querySelector('span').innerText.toLowerCase())) {
        statuscheckbox[i].querySelector('input').setAttribute('checked', true)
      }
    }

    let sortcheckbox = document.getElementsByClassName('checkbox-sort')
    for (let i = 0; i < sortcheckbox.length; i++) {
      if (this.sort.includes(sortcheckbox[i].querySelector('span').innerText.toLowerCase())) {
        sortcheckbox[i].querySelector('input').setAttribute('checked', true)
      }
    }
  },

  methods: {
    applyFilters: function () {
      let url = new URL(window.location.href);
      // strip pagination
      const matches = url.pathname.match(/^(.*)\/page\/\d+\/?$/)
      url.pathname = matches ? matches[1] : url.pathname
      this.technique ? url.searchParams.set("technique", this.technique) : url.searchParams.delete("technique")
      this.impact ? url.searchParams.set("impact", this.impact) : url.searchParams.delete("impact")
      this.tags ? url.searchParams.set("tags", this.tags) : url.searchParams.delete("tags")
      this.year ? url.searchParams.set("years", this.year) : url.searchParams.delete("years")
      this.sort.length > 0 ? url.searchParams.set("sortby", this.sort.toString().toLowerCase()) : url.searchParams.delete("sort")
      this.status.length > 0 ? url.searchParams.set("status", this.status.toString().toLowerCase()) : url.searchParams.delete("status")
      window.location = decodeURIComponent(url.href)
    },

    changeSort: function (e) {
      if (e.target.tagName.toLowerCase() === 'input') {
        if (e.target.checked) {
          if (this.sort.length < 1) {
            this.sort.push(e.target.value.toLowerCase())
          } else {
            alert('U kunt maar 1 sorteer optie selecteren');
            e.target.checked = false;
          }
        } else {
          this.sort.splice(this.sort.indexOf(e.target.value.toLowerCase()), 1)
        }
      }
    },

    changeStatus: function (name) {
      const index = this.status.indexOf(name);
      if (this.status.indexOf(name) === -1) {
        this.status.push(name);
      } else {
        this.status.splice(index, 1);
      }
    }
  }
}
</script>
